import { colorUseCases, css, getColorScaleValueByUseCase } from "@vitality-ds/system";
var text = colorUseCases.text;
export default css({
  paddingTop: "$xs",
  paddingInline: "$md",
  fontSize: "$caption",
  color: getColorScaleValueByUseCase("neutral", text.lowContrast)
});